// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"j1-z","sponsoredTooltipWrapper":"k1-z","sponsoredTooltip":"l1-z","newCard":"m1-z"};